import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Money from 'common/components/money';
import MessageTimeline from 'common/containers/message_timeline';
import Bundles from 'project/containers/wrapup/bundles';
import FaqList from 'common/components/faqs';
import {
  REFERRAL_MONEY_DISCOUNT, REFERRAL_FEATURE_DISCOUNT, REFERRAL_TOTAL_DISCOUNT
} from 'marketing/constants';
import SolicitationModal from 'project/components/wrapup/solicitation_modal';
import { MINI_PROJECT_SUBCAT_SLUG } from 'pap/constants';

const ONE_TO_ONE_QUESTIONS = [{
  question: "What is a 1-to-1 project?",
  answer: `
<p>A 1-to-1 project is when a client works privately with a single creative. Aside from that, it's similar to any other crowdspring project. The client and creative will be able to negotiate a price for the project before they begin work. Once you're both happy with the scope of the work and the price, work can begin.</p>
<p>1-to-1 projects include the same great features as regular crowdspring projects, including payment and escrow services, a free legal contract, and project management tools.</p>
<p>The project is also completely private - only the client and creative have access.</p>
`
}, {
  question: "How much does a 1-to-1 project cost?",
  answer: "You and the client can negotiate the price for a 1-to-1 project (minimum is $200, including all fees). A client can set a budget and invite you to accept, or ask you to quote a price based on the scope of work they need done. Ultimately, you set the final price!"
}, {
  question: "What kind of projects are best for 1-to-1?",
  answer: "If you just finished a logo project, you can offer to create business cards or stationery for the client. If you finished a website design project, you can offer to create specific landing pages they can use in their campaigns. Think about the work that would naturally follow the work you just completed and offer to continue working privately to help the client with their design needs."
}];

export default class PostFeedback extends Component {
  constructor(props) {
    super(props);

    this.state = { showingSolicitationModal: false };

    this.toggleSolicitationModal = this.toggleSolicitationModal.bind(this);
  }

  componentDidMount() {
    const { wrapup, fetchMessagesIfNeeded } = this.props;

    if (wrapup.post_wrapup_message_stream) {
      fetchMessagesIfNeeded({
        streamId: wrapup.post_wrapup_message_stream,
        wrapupStep: 'survey',
        wrapup
      });
    }
  }

  toggleSolicitationModal() {
    this.setState({ showingSolicitationModal: !this.state.showingSolicitationModal });
  }

  render() {
    const { wrapup, isCreative, isAdmin, invoicePdf } = this.props;
    const creativeUsername = wrapup.creative.username;
    const clientUsername = wrapup.client.username;
    let sendBtnLabel = "Send message to my creative";
    if (isCreative) {
      sendBtnLabel = "Send message to my client";
    } else if (isAdmin) {
      sendBtnLabel = "Send message to client and creative";
    }

    return (
      <div className="post-feedback">
        <div className="row">
          <div className="small-16 large-14 columns">
            <header className="step-header">
              <h3>
                Wrap-up completed for Award { wrapup.award.position }
                <span className="award-value"> (<Money value={wrapup.award.value} />)</span>
              </h3>
            </header>
          </div>
        </div>

        <div className="row section">
          <div className="small-16 columns">
            <div className="resources">
              <div className="row">
                { wrapup.final_bundles && wrapup.final_bundles.length > 0?
                <div className="small-16 medium-10 columns">
                  <Bundles wrapup={wrapup} bundles={wrapup.final_bundles} name="final files"
                    actionless={true} />
                </div> :
                <div className="small-16 medium-10 columns align-middle">
                  <h3>Thanks for your business!</h3>
                </div> }
                <div className="small-16 medium-6 columns links">
                  <h4>
                    <Link target="_blank" to={wrapup.contract.pdf_signed}>
                      <i className="fa fa-file-pdf-o" /> Download contract
                    </Link>
                  </h4>
                  { !isCreative && invoicePdf &&
                  <h4 className="invoice-pdf">
                    <Link target="_blank" to={invoicePdf}>
                      <i className="fa fa-dollar" /> Download invoice
                    </Link>
                  </h4> }
                </div>
              </div>
            </div>

            { isCreative &&
            <h4 className="text-center">
              How does your portfolio measure up? <br className="hide-for-large" />
              <Link target="_blank" to={`/users/${creativeUsername}/portfolio/`}>
                {' '}Update your portfolio now <i className="fa fa-long-arrow-right" />
              </Link>
            </h4> }

            { false && !isAdmin && !isCreative && !wrapup.entry.name &&
            <h4 className="text-center">
              Need small changes to the winning design? <br className="hide-for-large" />
              <Link target="_blank"
                  to={`/start-a-project/start-1-1/?subcat=${MINI_PROJECT_SUBCAT_SLUG}&one_to_one_creative=${creativeUsername}`}>
                {' '}Let { creativeUsername } know what you need{' '}
                <i className="fa fa-long-arrow-right" />
              </Link>
            </h4> }

            { !isAdmin && !isCreative && !wrapup.entry.name &&
            <h4 className="text-center">
              Love working with { creativeUsername }? <br className="hide-for-large" />
              <Link target="_blank"
                  to={`/start-a-project/start-1-1/?one_to_one_creative=${creativeUsername}`}>
                {' '}Invite them to a 1-to-1 project <i className="fa fa-long-arrow-right" />
              </Link>
            </h4> }

            { !isCreative && !!wrapup.entry.name &&
            <h4 className="text-center">
              Considering another project? <br className="hide-for-large" />
              <Link target="_blank" to="/help/contact/consultation/">
                {' '}Get a free design consultation <i className="fa fa-long-arrow-right" />
              </Link>
            </h4> }
          </div>
        </div>

        { isCreative && !isAdmin &&
        <div className="row section">
          <div className="small-16 medium-12 large-9 columns ask-more-work">
            <h3>Want more work from { clientUsername }?</h3>
            <p>
              1-to-1 projects are a great way to continue working together. Quick,
              easy, and secure.
            </p>
            <div className="faqs">
              <h3>FAQs</h3>
              <FaqList data={ONE_TO_ONE_QUESTIONS} showMore={true} />
            </div>
            <button className="btn btn-tertiary btn-block" onClick={this.toggleSolicitationModal}>
              Ask { clientUsername } about more work
            </button>
          </div>
        </div> }

        { !isCreative && !isAdmin &&
        <div className="row section">
          <div className="small-16 columns refer-a-friend">
            <div className="row">
              <div className="columns medium-10 small-16">
                <h3>Share your exclusive discount with a friend</h3>
                <p className="intro">
                  When a person you refer posts their project, both you and your friend
                  get { REFERRAL_MONEY_DISCOUNT } off a future project plus
                  our { REFERRAL_FEATURE_DISCOUNT } for free (total value: { REFERRAL_TOTAL_DISCOUNT }).
                  There's no limit to how many referrals you can send - you benefit from each project
                  posted by people you refer (make five referrals and use the discounts and free promotions on five future projects).
                </p>
                <Link target="_blank" to="/refer-a-friend" className="btn btn-primary btn-block">
                  I want to share my exclusive discount with a friend
                </Link>
              </div>
              <div className="columns medium-6 small-16 image-container">
                <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_cta2-2x.png" alt="crowdspring image designed by abu_hilmi"/>
              </div>
            </div>
          </div>
        </div> }

        { !!wrapup.post_wrapup_message_stream &&
        <div className="row">
          <div className="columns medium-4 small-16">
            <h3>Messages</h3>
          </div>
          <div className="columns medium-12 small-16">
            <MessageTimeline wrapup={wrapup} canPost={true} canAttach={false} canReply={false}
              editorActionLabel={sendBtnLabel} wrapupStep="survey" />
          </div>
        </div> }

        <SolicitationModal showing={this.state.showingSolicitationModal}
          onClose={this.toggleSolicitationModal} wrapup={wrapup} />
      </div>
    );
  }
}

PostFeedback.propTypes = {
  wrapup: PropTypes.object.isRequired,
  fetchMessagesIfNeeded: PropTypes.func.isRequired,
  isCreative: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  invoicePdf: PropTypes.string,
};



// WEBPACK FOOTER //
// ./project/components/wrapup/post_feedback.jsx